import React from "react";
import PropTypes from "prop-types";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import ControlPointIcon from "@material-ui/icons/ControlPoint";
import appleIcon from "../../Assets/Images/apple.svg";
import paymentMethodIcon from "../../Assets/Images/payment-method-icon.svg";
import ErrorModal from "../Shared/ErrorModal";
import LatestModalDesign from "../Shared/LatestModalDesign";
import SuccessModal from "../Shared/SuccessModal";
import AddNewPaymentMethod from "./AddNewPaymentMethod";
import LoadingOverlay from "../Shared/LoadingOverlay";
import { Elements } from "react-stripe-elements";
import { connect } from "react-redux";
import {
  getCreditCardsOfUser,
  setDefaultCreditCardOfUser,
  deleteCreditCardOfUser,
} from "../Shared/Helpers";
import { get } from "lodash";
import Visa from "../../Assets/Images/Visa.svg";
import Master from "../../Assets/Images/Mastercard.svg";
import Discover from "../../Assets/Images/Discover.svg";
import { ACTIVE_LANGUAGE_CODE, DE, US } from "../../constants";
import { Apple } from "@material-ui/icons";

const cardIcons = {
  visa: Visa, // Replace with visa icon if available
  mastercard: Master, // Replace with mastercard icon if available
  discover: Discover, // Replace with discover icon if available
  applepay: appleIcon,
  default: paymentMethodIcon,
};

function getCardIcon(type) {
  if (!type) return cardIcons.default;
  const key = type.toLowerCase();
  if (key.includes("visa")) return cardIcons.visa;
  if (key.includes("master")) return cardIcons.mastercard;
  if (key.includes("discover")) return cardIcons.discover;
  if (key.includes("apple")) return cardIcons.applepay;
  return cardIcons.default;
}

function getCardIconClass(type) {
  if (!type) return "width-35 height-24 obj-fit-contain";
  const key = type.toLowerCase();
  // Discover card has different aspect ratio, needs specific sizing
  if (key.includes("discover")) return "width-35 height-12 obj-fit-contain";
  return "width-35 height-24 obj-fit-contain";
}

function isCardExpired(card) {
  if (card.exp_month && card.exp_year) {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // getMonth() returns 0-11

    if (card.exp_year < currentYear) return true;
    if (card.exp_year === currentYear && card.exp_month < currentMonth)
      return true;
  }
  return false;
}

class PaymentMethodList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      showErrorModal: false,
      credit_cards: [],
      loading: true,
      selectedId: "",
      showAddModal: false,
      showDeleteConfirmModal: false,
      showSuccessModal: false,
      successMessage: "",
      successTitle: "",
      methodToDelete: null,
      width: 0,
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleDefault = this.handleDefault.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleAdd = this.handleAdd.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.isCardExpired = this.isCardExpired.bind(this);
    this.getCardBorderClass = this.getCardBorderClass.bind(this);
    this.showDeleteConfirmation = this.showDeleteConfirmation.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.closeDeleteConfirmModal = this.closeDeleteConfirmModal.bind(this);
    this.closeAddModal = this.closeAddModal.bind(this);
    this.closeSuccessModal = this.closeSuccessModal.bind(this);
    this.showSuccessMessage = this.showSuccessMessage.bind(this);
    this.handleAddSuccess = this.handleAddSuccess.bind(this);
  }

  componentDidMount() {
    this.loadCreditCards();
    this.setState({ width: window.innerWidth });
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.client?.user_id !== this.props.client?.user_id) {
      this.loadCreditCards();
    }
  }

  handleResize = () => {
    this.setState({ width: window.innerWidth });
  };

  loadCreditCards() {
    const loggedIn = get(this.props.client, "loggedIn", false);
    const userId = get(this.props.client, "user_id");

    if (loggedIn && userId) {
      this.setState({ loading: true });
      getCreditCardsOfUser(
        userId,
        (response) => {
          const cards = response?.data?.credit_cards || [];
          this.setState({
            credit_cards: cards,
            loading: false,
          });
        },
        (err) => {
          console.log("Error loading credit cards:", err);
          this.setState({
            loading: false,
            error: "Failed to load payment methods",
          });
        }
      );
    } else {
      this.setState({ loading: false });
    }
  }

  handleSelect(method) {
    const expired = this.isCardExpired(method);
    if (expired) return;

    if (this.props.onSelect) {
      this.props.onSelect(method);
    }
    this.setState({ selectedId: method.id });
  }

  handleDefault() {
    const { selectedId } = this.state;
    if (this.props.onDefault) {
      const method = this.state.credit_cards.find(
        (card) => card.id === selectedId
      );
      this.props.onDefault(method);
    }
    this.setState({ loading: true });
    setDefaultCreditCardOfUser(
      selectedId,
      () => {
        this.loadCreditCards();
        this.setState({ loading: false, selectedId: "" });
        this.showSuccessMessage(
          "Payment Method Updated",
          "Your default payment method has been updated successfully."
        );
      },
      (error) => {
        this.errorHandler(
          get(
            error,
            "response.data.errors.message",
            "Failed to set default payment method"
          )
        );
      }
    );
  }

  handleDelete(method, e) {
    e.stopPropagation();
    this.showDeleteConfirmation(method);
  }

  handleAdd() {
    if (this.props.onAdd) {
      this.props.onAdd();
    } else {
      this.setState({ showAddModal: true });
    }
  }

  errorHandler(errorMsg) {
    this.setState({ error: errorMsg, showErrorModal: true });
  }

  closeErrorModal() {
    this.setState({ showErrorModal: false, error: "" });
  }

  isCardExpired(card) {
    if (card.exp_month && card.exp_year) {
      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;
      if (card.exp_year < currentYear) return true;
      if (card.exp_year === currentYear && card.exp_month < currentMonth)
        return true;
    }
    return false;
  }

  formatCardDisplay(card) {
    const isCardExpired = this.isCardExpired(card);
    if (card.display_string) {
      return (
        <>
          <div
            className={`size-16-20 font-weight-bold contentPrimary mb-4 ${
              isCardExpired ? "opacity-05" : ""
            }`}
          >
            {card.display_string}
          </div>
          <div
            className={`size-14-20 ${
              isCardExpired ? "systemRed" : "contentSecondary"
            }`}
          >
            {isCardExpired ? "Expired" : "Expires"} {card.exp_date}
          </div>
        </>
      );
    }

    const last4 = card.last4 || "";
    const brand = card.type || "";

    if (last4 && brand) {
      return (
        <div
          className={`size-16-20 font-weight-bold contentPrimary mb-4 ${
            isCardExpired ? "opacity-05" : ""
          }`}
        >
          {`${brand} ••••${last4}`}
        </div>
      );
    }

    return (
      <div className="size-14-20 contentSecondary">
        {card.label || "Payment Method"}
      </div>
    );
  }

  getCardBorderClass(card, isSelected) {
    const expired = isCardExpired(card);
    const isDefault = card.default;
    const { selectedId } = this.state;
    const externalSelectedId = this.props.selectedId;

    if (isSelected) return "br-cactus-flower";
    if (expired) return "br-opaque";
    if (isDefault && !(externalSelectedId || selectedId)) return "br-cactus-flower";
    return "br-opaque";
  }

  getCardTextClass(card) {
    const expired = isCardExpired(card);
    if (expired) return "contentSecondary";
    return "contentPrimary";
  }

  getExpiryTextClass(card) {
    const expired = isCardExpired(card);
    if (expired) return "systemRed";
    return "contentSecondary";
  }

  showDeleteConfirmation(method) {
    this.setState({
      showDeleteConfirmModal: true,
      methodToDelete: method,
    });
  }

  confirmDelete() {
    const { methodToDelete } = this.state;
    if (!methodToDelete) return;

    this.setState({ loading: true, showDeleteConfirmModal: false });

    deleteCreditCardOfUser(
      methodToDelete.id,
      () => {
        this.loadCreditCards();
        this.setState({ loading: false, methodToDelete: null });
        this.showSuccessMessage(
          "Payment Method Deleted",
          "Your payment method has been successfully removed."
        );
      },
      (error) => {
        this.setState({ loading: false, methodToDelete: null });
        this.errorHandler(
          get(
            error,
            "response.data.errors.message",
            "Failed to delete payment method"
          )
        );
      }
    );
  }

  closeDeleteConfirmModal() {
    this.setState({
      showDeleteConfirmModal: false,
      methodToDelete: null,
    });
  }

  closeAddModal() {
    this.setState({ showAddModal: false });
  }

  closeSuccessModal() {
    this.setState({
      showSuccessModal: false,
      successMessage: "",
      successTitle: "",
    });
  }

  showSuccessMessage(title, message) {
    this.setState({
      showSuccessModal: true,
      successTitle: title,
      successMessage: message,
    });
  }

  handleAddSuccess(cardId) {
    this.loadCreditCards();
    this.showSuccessMessage(
      "Payment Method Added",
      "Your new payment method has been successfully added."
    );
  }

  render() {
    const {
      showAdd = false,
      showDelete = false,
      showDefault = false,
      selectedId: externalSelectedId,
    } = this.props;
    const {
      error,
      showErrorModal,
      credit_cards,
      loading,
      selectedId,
      showAddModal,
      showDeleteConfirmModal,
      showSuccessModal,
      successMessage,
      successTitle,
      methodToDelete,
      width,
    } = this.state;
    const countryCode = ACTIVE_LANGUAGE_CODE === DE ? DE : US;
    const fonts = [
      {
        src: 'url("https://www.soothe.com/static/media/GothamHTF-Book.48680770.otf")',
        family: "gotham",
      },
    ];

    return (
      <>
        {credit_cards.length === 0 && !loading ? (
          <div className="d-flex-only flex-direction-column align-items-center justify-content-center p-32">
            <div className="size-16-24 contentSecondary mb-16">
              No payment methods found
            </div>
          </div>
        ) : (
          credit_cards.map((method, idx) => {
            const isSelected = (externalSelectedId || selectedId) === method.id;
            const isDefault = method.default || method.isDefault;
            const expired = isCardExpired(method);
            const isApplePay = (method.type || "")
              .toLowerCase()
              .includes("apple");

            return (
              <div
                key={method.id || idx}
                className={`d-flex-only align-items-center justify-content-spaced p-16 br-rd-8 mb-16 cursor-pointer bg-white transition-all ${this.getCardBorderClass(
                  method,
                  isSelected
                )}`}
                onClick={() => this.handleSelect(method)}
              >
                {isApplePay ? (
                  <>
                    {/* // Apple Pay - just text, no icon */}
                    <div
                      className={`d-flex-only align-items-center height-48 ${
                        expired ? "opacity-05" : ""
                      }`}
                    >
                      <Apple className="mr-8" />
                    </div>
                    <div
                      className={`txt-left flex-1  ${
                        expired ? "opacity-05" : ""
                      }`}
                    >
                      <div className="size-16-20 font-weight-bold contentPrimary">
                        Apple Pay
                      </div>
                      {isDefault && (
                        <span
                          className={`CactusFlowerPrimary size-14-20 mt-4 ${
                            expired ? "opacity-05" : ""
                          }`}
                        >
                          Default Payment Method
                        </span>
                      )}
                    </div>
                    {showDelete && !isDefault && (
                      <button
                        type="button"
                        className="btn btn-link p-0 contentPrimary hover-cactus-flower txt-right"
                        onClick={(e) => this.handleDelete(method, e)}
                        aria-label="Delete payment method"
                        style={{
                          width: width >= 1000 ? "auto" : "24px",
                        }}
                      >
                        <DeleteOutlineIcon />
                      </button>
                    )}
                  </>
                ) : (
                  // Regular card with icon
                  <>
                    <div className="d-flex-only justify-content-center align-items-center width-64 height-48 ptb-12">
                      <img
                        src={getCardIcon(method.type)}
                        alt={method.brand || method.type || "card"}
                        className={`${getCardIconClass(method.type)} mr-8 ${
                          expired ? "opacity-05" : ""
                        }`}
                      />
                    </div>
                    <div className={`txt-left flex-1`}>
                      {this.formatCardDisplay(method)}
                      {isDefault && (
                        <span
                          className={`CactusFlowerPrimary size-14-20 mt-4 ${
                            expired ? "opacity-05" : ""
                          }`}
                        >
                          Default Payment Method
                        </span>
                      )}
                    </div>
                    {showDelete && !isDefault && (
                      <button
                        type="button"
                        className="btn btn-link p-0 contentPrimary hover-cactus-flower txt-right"
                        onClick={(e) => this.handleDelete(method, e)}
                        aria-label="Delete payment method"
                        style={{
                          width: width >= 1000 ? "auto" : "24px",
                        }}
                      >
                        <DeleteOutlineIcon />
                      </button>
                    )}
                  </>
                )}
              </div>
            );
          })
        )}

        {showAdd && (
          <div
            className="d-flex-only align-items-center justify-content-centered p-16 br-rd-8 mb-16 cursor-pointer bg-white border-1-gray hover-border-cactus-flower transition-all br-opaque"
            onClick={this.handleAdd}
          >
            <div className="d-flex-only justify-content-center align-items-center width-64 height-48 ptb-12">
              <ControlPointIcon className="width-24 height-24 contentPrimary" />
            </div>
            <div className="size-16-24 font-weight-bold contentPrimary">
              Add Payment Method
            </div>
          </div>
        )}
        {showDefault && credit_cards.length > 0 && (
          <div className="d-flex-only align-items-center justify-content-centered p-16 br-rd-8 mb-16 cursor-pointer bg-white transition-all">
            <button
              type="button"
              className="btn md-cta-primary resp-w-303"
              onClick={this.handleDefault}
              disabled={loading || !selectedId}
            >
              Save as Default
            </button>
          </div>
        )}

        {showErrorModal && (
          <ErrorModal isOpen={showErrorModal} close={this.closeErrorModal}>
            <p>{error}</p>
          </ErrorModal>
        )}

        {/* Delete Confirmation Modal */}
        {showDeleteConfirmModal && methodToDelete && (
          <LatestModalDesign
            isOpen={showDeleteConfirmModal}
            title="Delete Payment Method"
            close={this.closeDeleteConfirmModal}
            apply={this.confirmDelete}
            applyBtnCopy="Delete"
            cancelBtnCopy="Cancel"
            disabled={loading}
          >
            <div>
              <p className="size-16-24 contentPrimary mb-16">
                Are you sure you want to delete this payment method?
              </p>
              <div className="d-flex align-items-center mb-16">
                <img
                  src={getCardIcon(methodToDelete.type)}
                  alt={methodToDelete.brand || methodToDelete.type || "card"}
                  className={`${getCardIconClass(methodToDelete.type)} mr-12`}
                />
                <p className="size-14-20 contentSecondary m-0">
                  {methodToDelete.display_string ||
                    `${methodToDelete.type || ""} ••••${
                      methodToDelete.last4 || ""
                    }`}
                </p>
              </div>
              <p className="size-12-16 contentTertiary mt-8">
                This action cannot be undone.
              </p>
            </div>
          </LatestModalDesign>
        )}

        {/* Success Modal */}
        {showSuccessModal && (
          <SuccessModal
            isOpen={showSuccessModal}
            title={successTitle}
            subtitle={successMessage}
            action={this.closeSuccessModal}
            ctaText="Continue"
          />
        )}

        {/* Add Payment Method Modal */}
        <Elements locale={countryCode} fonts={fonts}>
          <AddNewPaymentMethod
            isOpen={showAddModal}
            onClose={this.closeAddModal}
            onSuccess={this.handleAddSuccess}
          />
        </Elements>

        <LoadingOverlay showLoader={loading} />
      </>
    );
  }
}

PaymentMethodList.propTypes = {
  onSelect: PropTypes.func,
  onDefault: PropTypes.func,
  onAdd: PropTypes.func,
  showAdd: PropTypes.bool,
  showDelete: PropTypes.bool,
  showDefault: PropTypes.bool,
  selectedId: PropTypes.string,
  client: PropTypes.object,
};

const mapStateToProps = (state) => ({
  client: state.client,
});

export default connect(mapStateToProps, {})(PaymentMethodList);
